<template>
  <div class="w-100">
    <error-banner v-if="error" :message="error"/>
    <pet-details v-for="(pet, index) in petCaches" :key="pet.id" :pet-index="index"/>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { PetCacheMixin } from '@/mixins/Registration/PetCacheMixin'
import { ClientOnboardingInviteCacheMixin } from '@/mixins/Registration/ClientOnboardingInviteCacheMixin'
import PetDetailsSection from './PetDetailsSection.vue'
import ErrorBanner from '@/components/ErrorValidation/ErrorBanner.vue'

export default {
  name: 'PetsList',
  mixins: [PetCacheMixin, ClientOnboardingInviteCacheMixin],
  computed: {
    petCacheIds () {
      if (this.petCaches.length < 1) {
        return []
      }
      const pets = JSON.parse(JSON.stringify(this.petCaches))
      return pets.map(pet => pet.id)
    }
  },
  watch: {
    updatedPets () {
      const allExist = this.petCacheIds.every(id => this.updatedPets.includes(id))
      if (allExist && this.petCacheIds.length > 0) {
        this.setPetDetailsUpdated()
      }
    },
    updatedPetNotes () {
      const allExist = this.petCacheIds.every(id => this.updatedPetNotes.includes(id))
      if (allExist && this.petCacheIds.length > 0) {
        this.setPetNoteUpdated()
      }
    }
  },
  methods: {
    ...mapMutations('ClientOnboardingInvites', [
      'setPetDetailsUpdated',
      'setPetNoteUpdated'
    ])
  },
  components: {
    'pet-details': PetDetailsSection,
    'error-banner': ErrorBanner
  }
}
</script>
